import Model from './Model'

export default class Customfield extends Model {
    resource() {
        return 'customfield';
    }


    // update the customfield
    customfieldUpdate(data) {
        return this.request({
            url: `${this.resource()}/${data.id}`,
            method: 'put',
            data: {
                identifier: data.identifier,
                type: data.type,
                fieldlabel: data.fieldlabel,
                fieldplaceholder: data.fieldplaceholder,
                fieldoptions: data.fieldoptions,
                mandatory: data.mandatory,
                default: data.default,
                icon: data.icon,
            }
        });
    }


    // delete the customfield
    customfieldDelete(id) {
        return this.request({
            url: `${this.resource()}/${id}`,
            method: 'delete',
        });
    }
    
}
